import { DefaultsApi, useAPIQuery } from "melco-shared-logic";

export const useRefferalDropDownData = () => {
  return useAPIQuery(
    DefaultsApi,
    ["refferalDropDownData"],
    async (api) => {
      //const api = new SystemDefaultsApi(baseApiConfig({ token }));

      //api.defaultsGetReferralList
      const response = await api.defaultsGetReferralList();

      return response;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );
};
